import { useMediaQuery } from "@mantine/hooks";

/**
 * 모바일 화면 여부 확인
 * @returns {boolean}
 */

export function useMobile() {
  const isDesktop = useMediaQuery("(min-width: 48em)", false);
  return !isDesktop;
}
